import { render, staticRenderFns } from "./RsvpFormBuilder.vue?vue&type=template&id=196c839f"
import script from "./RsvpFormBuilder.vue?vue&type=script&lang=js"
export * from "./RsvpFormBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports